import styled from '@emotion/styled';
import { Checkbox, Popover, Tooltip } from 'antd';
import DownSvg from 'assets/svg/Down';
import DownAltSvg from 'assets/svg/DownAlt';
import Search from 'assets/svg/Search';
import SearchAltSvg from 'assets/svg/SearchAlt';
import UpAltSvg from 'assets/svg/UpAlt';
import Scorecard from 'components/atoms/Scorecard';
import { colorConstants } from 'config/colorConstants';
import _ from 'lodash';
import React, { useMemo, useState } from 'react';
import { renderTitle } from './getSalesAttributionColumns';
import { trackEventMixpanel } from './mixpanel';
import {
    PORTFOLIO_ANALYSIS_MEDIA_SPENDS_ATTRIBUTE_CHANGED,
    PORTFOLIO_ANALYSIS_MEDIA_SPENDS_MEDIA_TYPES_CHANGED,
    PORTFOLIO_ANALYSIS_TABLE_HEADER_MECHANICS_FILTER,
    PORTFOLIO_ANALYSIS_TABLE_HEADER_TACTICS_FILTER,
} from './mixpanelEventNames';
import { graphXAxisLabelFontSize } from 'components/organism/GrowthAnalysis/BrandValueChartContainer/BrandValueChartContainer';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

const CustomCheckbox = styled(Checkbox)`
    .ant-checkbox-inner {
        border: 1px solid ${colorConstants.borderGrey};
    }
    .ant-checkbox-checked .ant-checkbox-inner {
        background: ${colorConstants.violet};
        border: 1px solid ${colorConstants.violet};
    }
`;

export const getPortfolioAnalysisTableColumns = (
    data: any,
    headerData: any,
    setFilterStates: Function,
    tableHeaders: any[],
) => {
    const result: any[] = [];
    if (Array.isArray(tableHeaders) && headerData) {
        tableHeaders?.map((headerItem, idx) => {
            const key = headerItem?.value;
            //for first 2 columns
            let temp = {};
            if (idx < 2) {
                temp = {
                    title:
                        idx === 1 ? (
                            <HeaderDropdown
                                setFilterStates={setFilterStates}
                                header={headerItem}
                                headerData={headerData[key]}
                                filterData={headerData}
                            />
                        ) : (
                            renderTitle(key, undefined, undefined, 'text-purpleFont !font-bold')
                            // <HeaderAttributesDropdown
                            //     setSelectedAttributeItem={setSelectedAttributeItem}
                            //     selectedAttributeItem={selectedAttributeItem}
                            //     headerData={attributesDropdownData}
                            // />
                        ),
                    dataIndex: key,
                    width: key === 'type' ? 150 : 160,
                    key: key,
                    align: 'center',
                    fixed: idx === 0 || idx === 1 ? 'left' : false,
                    onCell: (data: any, index: number) => {
                        return {
                            style: {
                                border: `1px solid ${colorConstants.borderGreyAlt}`,
                            },
                        };
                    },

                    render: (columnData: any, rowData: any, index: number) => {
                        return {
                            props: {
                                rowSpan: columnData?.rowSpan,
                            },
                            children: (
                                <div
                                    className="font-xs"
                                    // style={{
                                    //     ...categoryImpactedCommonStyles,
                                    // }}
                                >
                                    {columnData?.data}
                                </div>
                            ),
                        };
                    },
                };
                //for rest of columns
            } else {
                temp = {
                    title:
                        idx === 2 ? (
                            <HeaderDropdown
                                header={headerItem}
                                setFilterStates={setFilterStates}
                                headerData={headerData[key]}
                                filterData={headerData}
                            />
                        ) : (
                            renderTitle(
                                key,
                                undefined,
                                undefined,
                                'text-purpleFont !font-bold',
                                graphXAxisLabelFontSize,
                            )
                        ),
                    dataIndex: key,
                    width: key === 'type' ? 150 : 160,
                    key: key,
                    align: idx === 0 ? 'left' : 'center',
                    fixed: idx === 0 || idx === 1 ? 'left' : false,
                    onCell: (data: any, index: number) => {
                        return {
                            style: {
                                border: `1px solid ${colorConstants.borderGreyAlt}`,
                            },
                        };
                    },
                    // sorter:
                    //     idx === 0
                    //         ? false
                    //         : (a: any, b: any, c: any, d: any) => {
                    //               return a[key] - b[key];
                    //           },
                    render: (columnData: any, rowData: any, index: number) => {
                        const renderScoreCard = typeof columnData === 'object' && 'color' in columnData;
                        return {
                            props: {
                                rowSpan: 1,
                            },
                            children: (
                                <div
                                    style={{ overflowWrap: 'anywhere' }}
                                    className="flex font-xs justify-center"
                                    // style={{
                                    //     ...categoryImpactedCommonStyles,
                                    // }}
                                >
                                    {renderScoreCard ? (
                                        <Scorecard color={columnData?.color} value={columnData?.data} />
                                    ) : (
                                        columnData?.data
                                    )}
                                </div>
                            ),
                        };
                    },
                };
            }

            result.push(temp);
        });
    }

    return result;
};

export const getPortfolioAnalysisTableColumnsV2 = (
    columns: any[],
    filterStates: any,
    setFilterStates: Function,
    sortObj: any,
) => {
    let result: any[] = [];
    result = columns?.map((header: any, index: number) => {
        return {
            title: header?.multiSelectFilter ? (
                <HeaderDropdown
                    setFilterStates={setFilterStates}
                    header={header}
                    headerData={filterStates?.[header?.value]}
                    filterData={filterStates}
                />
            ) : (
                <p className={`font-xs text-purpleFont `}>{header?.label}</p>
            ),
            sortKey: header?.sortKey, //adding a sort key so that on sort click we can read value from this key
            sortOrder: header?.sortKey === sortObj?.sortBy ? sortObj?.sortOrder : null, //condition to highlight sort arrow according to selection
            sorter: header?.sortKey ? true : false,
            sortDirections: ['ascend', 'descend', 'ascend'], //always have some sorting
            dataIndex: header.value,
            width: 200,
            key: header.value,
            fixed: header?.dimension && index < 3 ? 'left' : false,
            align: 'center',
            // onCell: (record: any, rowIndex: any) => {
            //     let style: React.CSSProperties = { padding: 0, border: '' };

            //     return { style };
            // },
            render: (columnData: any, rowData: any, index: number) => {
                if (typeof columnData === 'string') {
                    return <div className="font-xs text-black">{columnData}</div>;
                }
                const scorecardValue =
                    columnData?.value != null ? `${header?.pre ?? ''}${columnData.value}${header?.post ?? ''}` : '';
                return <Scorecard color={columnData?.color} style={{ marginInline: 'auto' }} value={scorecardValue} />;
            },
        };
    });

    return result;
};

export const getPortfolioAnalysisMediaTableColumns = (
    data: any,
    headerData: any,
    setFilterStates: Function,
    tableHeaders: any[],
    mediaSpendsAttributeOptions: any,
    selectedAttribute: any,
    setSelectedAttribute: Function,
    openAttributeDropdown: boolean,
    setOpenAttributeDropdown: Function,
) => {
    const result: any[] = [];

    if (Array.isArray(tableHeaders) && headerData) {
        tableHeaders?.map((headerItem, idx) => {
            const key = headerItem;
            let temp = {};
            if (idx === 0) {
                temp = {
                    title: (
                        <span style={{ borderTop: `1px solid ${colorConstants.borderGreyAlt}` }} className="h-6">
                            <Popover
                                autoAdjustOverflow
                                content={() => {
                                    return (
                                        <div style={{ minWidth: '100px' }}>
                                            {mediaSpendsAttributeOptions.map((i: any) => (
                                                <div
                                                    key={i.key}
                                                    onClick={(e) => {
                                                        setSelectedAttribute(i);
                                                        setOpenAttributeDropdown(false);
                                                        trackEventMixpanel(
                                                            PORTFOLIO_ANALYSIS_MEDIA_SPENDS_ATTRIBUTE_CHANGED,
                                                            {
                                                                dropdownValue: i?.label,
                                                            },
                                                        );
                                                    }}
                                                    className={`cursor-pointer py-1 px-4 pr-8 font-xxs mr-1 text-black ${
                                                        i.label === selectedAttribute.label ? 'bg-bgBackground  ' : ''
                                                    }`}
                                                >
                                                    {i.label}
                                                </div>
                                            ))}
                                        </div>
                                    );
                                }}
                                destroyTooltipOnHide
                                trigger="click"
                                onOpenChange={(e) => setOpenAttributeDropdown(e)}
                                open={openAttributeDropdown}
                                showArrow={false}
                                placement="bottomLeft"
                                overlayClassName="popover-padding-remove"
                            >
                                <span
                                    className={`flex gap-2 text-purpleFont font-bold rounded justify-around items-center cursor-pointer px-1 ml-4 p-2 ${
                                        openAttributeDropdown ? 'bg-darkViolet' : ''
                                    } `}
                                >
                                    {selectedAttribute?.label}
                                    {openAttributeDropdown ? <UpAltSvg /> : <DownAltSvg />}
                                </span>
                            </Popover>
                        </span>
                    ),
                    dataIndex: selectedAttribute.label,
                    width: 150,
                    key: selectedAttribute.label,
                    fixed: true,
                    align: 'center',
                    onCell: (record: any, rowIndex: any) => {
                        let style: React.CSSProperties = { padding: 0, border: '' };
                        if (idx === 0) {
                            style = { ...style, paddingLeft: 8 };
                        }
                        return { style };
                    },
                    render: (columnData: any, rowData: any, index: number) => {
                        return {
                            props: {
                                rowSpan: columnData?.rowSpan,
                            },
                            children: <div className="font-xs text-black">{columnData?.data}</div>,
                        };
                    },
                };
            } else if (idx === 1) {
                temp = {
                    title:
                        idx === 1 ? (
                            <HeaderDropdown
                                setFilterStates={setFilterStates}
                                header={{ label: headerItem, value: headerItem }}
                                headerData={headerData[key]}
                                filterData={headerData}
                            />
                        ) : (
                            renderTitle(
                                key,
                                undefined,
                                undefined,
                                'text-purpleFont !font-bold',
                                graphXAxisLabelFontSize,
                            )
                        ),
                    dataIndex: key,
                    width: key === 'type' ? 150 : 160,
                    key: key,
                    align: 'center',
                    fixed: idx === 1 ? 'left' : false,
                    onCell: (data: any, index: number) => {
                        return {
                            style: {
                                border: `1px solid ${colorConstants.borderGreyAlt}`,
                            },
                        };
                    },
                    render: (columnData: any, rowData: any, index: number) => {
                        return {
                            props: {
                                rowSpan: columnData?.rowSpan,
                            },
                            children: <div className="font-xs text-black ">{columnData?.data}</div>,
                        };
                    },
                };
                //for rest of columns
            } else {
                temp = {
                    title: renderTitle(
                        key,
                        undefined,
                        undefined,
                        'text-purpleFont !font-bold',
                        graphXAxisLabelFontSize,
                    ),
                    dataIndex: key,
                    width: key === 'type' ? 150 : 160,
                    key: key,
                    align: idx === 0 ? 'left' : 'center',
                    fixed: idx === 0 || idx === 1 ? 'left' : false,
                    onCell: (data: any, index: number) => {
                        return {
                            style: {
                                border: `1px solid ${colorConstants.borderGreyAlt}`,
                            },
                        };
                    },
                    // sorter:
                    //     idx === 0
                    //         ? false
                    //         : (a: any, b: any, c: any, d: any) => {
                    //               return a[key] - b[key];
                    //           },
                    render: (columnData: any, rowData: any, index: number) => {
                        const renderScoreCard = typeof columnData === 'object' && 'color' in columnData;
                        return {
                            props: {
                                rowSpan: 1,
                            },
                            children: (
                                <div
                                    style={{ overflowWrap: 'anywhere' }}
                                    className="flex font-xs justify-center"
                                    // style={{
                                    //     ...categoryImpactedCommonStyles,
                                    // }}
                                >
                                    {renderScoreCard ? (
                                        <Scorecard color={columnData?.color} value={columnData?.data} />
                                    ) : (
                                        columnData?.data
                                    )}
                                </div>
                            ),
                        };
                    },
                };
            }

            result.push(temp);
        });
    }

    return result;
};

//header with dropdown
const HeaderDropdown = React.memo(
    ({
        header,
        headerData,
        setFilterStates,
        filterData,
    }: {
        filterData: any;
        header: any;
        headerData: any;
        setFilterStates: Function;
    }) => {
        const [isOpen, setIsOpen] = useState(false);
        const content = (
            <div className=" min-w-[170px]">
                <div className="max-h-[125px] min-h-[100px] overflow-auto">
                    {!headerData?.length ? (
                        <div className="text-center p-6">No Data</div>
                    ) : (
                        <RenderList
                            filterData={filterData}
                            items={headerData}
                            setFilterStates={setFilterStates}
                            labelKey={header}
                        />
                    )}
                </div>
            </div>
        );

        const handleOpenChange = (value: boolean) => {
            setIsOpen(value);
        };

        return (
            <Popover
                open={isOpen}
                onOpenChange={handleOpenChange}
                content={content}
                trigger="click"
                placement="bottom"
                showArrow={false}
                destroyTooltipOnHide
            >
                <div
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                    className={`flex gap-2 items-center justify-center cursor-pointer py-2 rounded ${
                        isOpen ? 'bg-darkViolet mr-10' : 'mr-10'
                    }`}
                >
                    <p className="text-purpleFont !font-bold font-xs">{header?.label}</p>
                    {isOpen ? <UpAltSvg /> : <DownSvg />}
                </div>
            </Popover>
        );
    },
);

//header with dropdown - attributes
const HeaderAttributesDropdown = React.memo(
    ({
        headerData,
        setSelectedAttributeItem,
        selectedAttributeItem,
    }: {
        headerData: any[];
        setSelectedAttributeItem: Function;
        selectedAttributeItem: any;
    }) => {
        const [isOpen, setIsOpen] = useState(false);

        function handleCheckboxChange(e: CheckboxChangeEvent, item: any) {
            if (!e.target.checked) return;
            setIsOpen(false);
            setSelectedAttributeItem(item);
        }
        const content = (
            <div className=" min-w-[150px]">
                <div className="max-h-[125px] min-h-[100px] overflow-auto">
                    {!headerData?.length ? (
                        <div className="text-center">No Data</div>
                    ) : (
                        headerData.map((item: any, index: number) => {
                            return (
                                <div key={index} className="flex items-center gap-1">
                                    <label className="flex items-center gap-1 cursor-pointer">
                                        <CustomCheckbox
                                            checked={item.value === selectedAttributeItem?.value}
                                            onChange={(e) => handleCheckboxChange(e, item)}
                                        />
                                        <p className="font-xxs text-greyFont">{item.label}</p>
                                    </label>
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        );

        const handleOpenChange = (value: boolean) => {
            setIsOpen(value);
        };

        return (
            <Popover
                open={isOpen}
                onOpenChange={handleOpenChange}
                content={content}
                trigger="click"
                placement="bottom"
                showArrow={false}
                destroyTooltipOnHide
            >
                <div
                    className={`flex gap-1.5 items-center justify-center cursor-pointer py-2 rounded ${
                        isOpen ? 'bg-darkViolet' : ''
                    }`}
                >
                    <p className="text-purpleFont !font-bold font-xs">{selectedAttributeItem?.label}</p>
                    {isOpen ? <UpAltSvg /> : <DownSvg />}
                </div>
            </Popover>
        );
    },
);

//list render
const RenderList = ({
    items,
    filterData,
    labelKey,
    setFilterStates,
}: {
    items: any[];
    labelKey: any;
    filterData: any;
    setFilterStates: Function;
}) => {
    // const [updatedItems, setUpdatedItems] = useState(_.cloneDeep(items));
    const handleCheckboxChange = (e: any, item: any, index: any) => {
        if (labelKey?.value?.toLowerCase() === 'promotion_mechanic') {
            trackEventMixpanel(PORTFOLIO_ANALYSIS_TABLE_HEADER_MECHANICS_FILTER, {
                dropdownValue: item?.label,
                isChecked: !item.selected,
            });
        } else if (labelKey?.value?.toLowerCase() === 'media type') {
            trackEventMixpanel(PORTFOLIO_ANALYSIS_MEDIA_SPENDS_MEDIA_TYPES_CHANGED, {
                dropdownValue: item?.label,
                isChecked: !item.selected,
            });
        } else {
            trackEventMixpanel(PORTFOLIO_ANALYSIS_TABLE_HEADER_TACTICS_FILTER, {
                dropdownValue: item?.label,
                isChecked: !item.selected,
            });
        }

        let temp: any = [...items];
        if (item.key === 'select all') {
            temp = temp.map((item: any) => {
                return {
                    ...item,
                    selected: Boolean(e.target.checked),
                };
            });
        } else {
            temp = [...temp];
            temp[index].selected = Boolean(e.target.checked);
        }
        let isSelectAllChecked = true;
        temp.forEach((item: any, index: number) => {
            if (!item.selected && index !== 0) return (isSelectAllChecked = false);
        });
        temp[0].selected = isSelectAllChecked;
        setFilterStates({ ...filterData, [labelKey?.value]: temp });
    };

    return (
        <div>
            {items.map((item, index: number) => {
                return (
                    <div key={index} className="flex items-center gap-1">
                        <label
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                            className="flex items-center gap-1 cursor-pointer"
                        >
                            <CustomCheckbox
                                checked={item.selected}
                                onChange={(e) => handleCheckboxChange(e, item, index)}
                            />
                            <p className="font-xxs text-greyFont">{item.label}</p>
                        </label>
                    </div>
                );
            })}
        </div>
    );
};
